import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {style} from 'typestyle';
import {constantHeaderHeight} from '../theme/constant';
import {colorBackground, colorSlate} from '../theme/color';
import {centerCenter, vertical} from 'csstips';
import {percent} from 'csx';
import MainWrapper from '../components/main-wrapper';

export interface EditorPageProps {}

@inject(deps) @observer
export class EditorPage extends Component<EditorPageProps> {
  private $video: HTMLVideoElement;

  state = {
    objectUrl: null,
    duration: 0,
    position: 0,
  };

  render() {
    const {
      objectUrl,
      duration,
      position
    } = this.state;

    const positionStyle = {
      width: `${100 * (position/duration)}%`
    };

    return (
      <MainWrapper className={EditorPage.styles.container}>
        <div className={EditorPage.styles.videoContainer}>
          <video
            ref={el => this.$video = el}
            className={EditorPage.styles.video}
            src={objectUrl}
            onLoadedMetadata={this.handleLoadedMetadata}
            onSeeked={this.handleProgress}
            onTimeUpdate={this.handleProgress}
            controls={true}
          />
        </div>
        <input onChange={this.handleInput} type="file" accept="video/*"/>
        <div>
          <div
            className={EditorPage.styles.positionContainer}
            onMouseDown={this.positionMouseDown}
            onTouchStart={this.positionTouchStart}
          >
            <div
              style={positionStyle}
              className={EditorPage.styles.positionBar}
            />
          </div>
          <div>
            <div>
              Clip video track
            </div>
            <div>
              Clip audio track
            </div>
            <div>
              Lickd audio track
            </div>
            <div>
              + new track
            </div>
          </div>
        </div>
      </MainWrapper>
    )
  }

  handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files[0];

    this.loadFile(file);
  };

  handleLoadedMetadata = () => this.setState({duration: this.$video.duration});
  handleProgress = () => this.setState({position: this.$video.currentTime});

  positionMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.button !== 0) return; // left-click only
    event.stopPropagation();
    event.preventDefault();
    this.positionSeekingStart(event.clientX);
  };

  positionTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    event.stopPropagation();
    this.positionSeekingStart(event.touches[0].clientX);
  };

  positionSeekingStart = (clientX: number) => {

  };

  loadFile = (file: File) => this.setState({objectUrl: URL.createObjectURL(file)});

  static styles = {
    container: style({
      ...vertical,
      width: percent(100),
      marginTop: constantHeaderHeight,
      background: colorSlate.darken(0.075).toString()
    }),
    videoContainer: style({
      ...centerCenter,
      flex: 1
    }),
    video: style({
      width: percent(100)
    }),
    positionContainer: style({
      position: 'relative',
      height: constantHeaderHeight
    }),
    positionBar: style({
      height: constantHeaderHeight,
      background: colorBackground.toString(),
      position: 'absolute',
      willChange: 'width',
      top: 0,
      left: 0,
      bottom: 0,
    }),
  }
}